import { css } from "@emotion/core";
import { mq } from "../../cssInJs";

export default {
  top: css(
    mq({
      // height: [44, null, 82],
      height: [75, null, 150],
      background: "#E7E1DE",
      position: "fixed",
      width: "100%",
      zIndex: "999",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.3s",
    })
  ),
  // topScrolled: css(mq({
  //   height: [44, null, 56],
  // })),
  logo: css(mq({})),
  logoImg: css(
    mq({
      display: "block",
      // height: [42, null, 70],
      height: [58, null, 100]
    })
  ),
  logoScrolled: css(mq({})),
};
